import { NewsList } from './List.jsx';
import { NewsEdit } from './Edit.jsx';
import { NewsCreate } from './Create.jsx';
import ArticleIcon from '@mui/icons-material/Article';

export default {
  list: NewsList,
  edit: NewsEdit,
  create: NewsCreate,
  icon: ArticleIcon,
  options: { label: 'News & stories' },
  recordRepresentation: 'title',
};
